/**
 * Client entry point.
 *
 * i18n is initialised before the first render so no component ever mounts
 * without its translations, and the referral code is captured before the router
 * exists: the query string has to be read there, and the capture must happen for
 * every route, including ones that end up not matching.
 */

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { App } from './App'
import { setupI18n } from './lib/i18n'
import { captureReferral } from './lib/referral-capture'
import './index.css'

const container = document.getElementById('root')
if (!container) {
  throw new Error('#root container is missing from index.html')
}

setupI18n()
captureReferral()

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
